import React from "react";
import footerLogo from "./assets/footer-logo.png";
import fbIcon from "./assets/fb.svg";
import linkedinIcon from "./assets/in.svg";
import igIcon from "./assets/ig.svg";
import twitterIcon from "./assets/twitter.svg";
import youtubeIcon from "./assets/youtube.svg";
import github from "./assets/github.svg";
import "./Footer.scss";
import { NavLink } from "react-router-dom";

interface footerProps {
  isFinancialInquiries?: boolean;
  active?: string;
}

const socials = [
  { href: "https://www.facebook.com/SkillSurfEdu/", icon: fbIcon, label: "Facebook" },
  { href: "https://www.instagram.com/skillsurfedu/", icon: igIcon, label: "Instagram" },
  { href: "https://www.linkedin.com/company/skillsurfedu/", icon: linkedinIcon, label: "LinkedIn" },
  { href: "https://twitter.com/SkillSurfEdu", icon: twitterIcon, label: "Twitter" },
  { href: "https://www.youtube.com/@skillsurfedu", icon: youtubeIcon, label: "YouTube" },
  { href: "https://github.com/SkillSurf", icon: github, label: "GitHub" },
];

const policies = [
  { to: "/refund-policy", label: "Refund Policy", key: "refund-policy" },
  { to: "/privacy-policy", label: "Privacy Policy", key: "privacy-policy" },
  { to: "/terms-and-conditions", label: "Terms and Conditions", key: "terms-and-conditions" },
];

const Footer: React.FC<footerProps> = (props) => {
  return (
    <footer className="ss-footer">
      <div className="ss-container ss-footer__grid">
        <div className="ss-footer__brand">
          <img src={footerLogo} alt="Skill Surf Logo" width={155} height={51} />
          <p>Empowering all our learners to be industry and life&#8209;ready.</p>
          <ul className="ss-footer__socials">
            {socials.map((social) => (
              <li key={social.label}>
                <a
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.label}
                >
                  <img src={social.icon} alt="" aria-hidden="true" />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <nav className="ss-footer__col" aria-label="Explore">
          <h2>Explore</h2>
          <ul>
            <li>
              <NavLink to="/program-catalog">Program Catalog</NavLink>
            </li>
            <li>
              <NavLink to="/about-us">About Us</NavLink>
            </li>
            <li>
              <NavLink to="/pathways">Learning Pathways</NavLink>
            </li>
            <li>
              <NavLink to="/resources">Resources</NavLink>
            </li>
            <li>
              <NavLink to="/gallery">Gallery</NavLink>
            </li>
            <li>
              <NavLink to="/contact-us">Contact Us</NavLink>
            </li>
            <li>
              <a href="https://learnova.skillsurf.lk/" target="_blank" rel="noopener noreferrer">
                Learnova
              </a>
            </li>
          </ul>
        </nav>

        <nav className="ss-footer__col" aria-label="Policies">
          <h2>Policies</h2>
          <ul>
            {policies.map((policy) => (
              <li key={policy.key}>
                <NavLink
                  to={policy.to}
                  className={props.active === policy.key ? "is-active" : ""}
                >
                  {policy.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="ss-footer__col">
          <h2>Contact</h2>
          <ul>
            <li>
              <a href="mailto:skillsurfedu@gmail.com" className="ss-footer__mail">
                <i className="bi bi-envelope" aria-hidden="true"></i>
                skillsurfedu@gmail.com
              </a>
            </li>
            {props.isFinancialInquiries && (
              <li className="ss-footer__note">
                Financial inquiries:
                <a href="mailto:carelfinances@gmail.com">carelfinances@gmail.com</a>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="ss-footer__bar">
        <div className="ss-container">&#169; 2021-2026 skillsurf.org</div>
      </div>
    </footer>
  );
};

export default Footer;
